export const Props = () => ({
  //--------------------------------------------------------------------------
  //                        Массив с данными трендовых монет
  //--------------------------------------------------------------------------
  trendingCoins: {
    type: Array,
    default: () => []
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                            Идет процесс загрузки данных?
  //----------------------------------------------------------------------------
  isLoading: {
    type: Boolean,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

  //----------------------------------------------------------------------------
  //                           Монеты из результата поиска?
  //----------------------------------------------------------------------------
  isSearchResult: {
    type: Boolean,
    required: false,
  },
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});